/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { DataSourceSchemaPropertyType_$type } from "igniteui-react-core";
import { enumGetBox, runOn, delegateCombine, typeCast, markType } from "igniteui-react-core";
import { EditorType_$type } from "./EditorType";
import { Popup } from "igniteui-react-layouts";
import { InputGroup } from "igniteui-react-inputs";
import { Input } from "igniteui-react-inputs";
import { IDataSource_$type } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { BaseDOMEventProxy } from "igniteui-react-core";
import { dateGetMonth } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCell, _super);
    function EditorCell(a) {
        var _this = _super.call(this, a) || this;
        _this.ct = null;
        _this.cs = null;
        _this.cl = null;
        _this.cm = null;
        _this.cb = null;
        _this.ca = null;
        _this.cn = null;
        _this.b9 = null;
        _this.cx = null;
        _this.co = null;
        _this.cp = null;
        _this.cq = null;
        _this.cr = null;
        _this.cc = null;
        _this.cf = false;
        _this.b5 = 0;
        _this.cz = null;
        _this.cd = null;
        _this.b7 = 0;
        _this.cy = null;
        _this.c2 = null;
        _this.b3 = null;
        _this.ch = false;
        _this.ci = false;
        _this.cg = false;
        _this.z.setAttribute("tabindex", "-1");
        _this.z.setStyleProperty("outline", "none");
        _this.z.setStyleProperty("display", "flex");
        _this.z.setStyleProperty("align-items", "center");
        _this.z.listen("keydown", runOn(_this, _this.dp));
        _this.z.listen("focusout", runOn(_this, _this.dn));
        _this.z.listen("focusin", runOn(_this, _this.dm));
        return _this;
    }
    Object.defineProperty(EditorCell.prototype, "b6", {
        get: function () {
            return this.b5;
        },
        set: function (a) {
            var b = this.b5;
            this.b5 = a;
            if (b != this.b5) {
                this.bd("DataType", enumGetBox(DataSourceSchemaPropertyType_$type, b), enumGetBox(DataSourceSchemaPropertyType_$type, this.b5));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "c1", {
        get: function () {
            return this.cz;
        },
        set: function (a) {
            var b = this.cz;
            this.cz = a;
            if (b != this.cz) {
                this.bd("Value", b, this.cz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "ce", {
        get: function () {
            return this.cd;
        },
        set: function (a) {
            var b = this.cd;
            this.cd = a;
            if (b != this.cd) {
                this.bd("FontInfo", b, this.cd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "b8", {
        get: function () {
            return this.b7;
        },
        set: function (a) {
            var b = this.b7;
            this.b7 = a;
            if (b != this.b7) {
                this.bd("EditorType", enumGetBox(EditorType_$type, b), enumGetBox(EditorType_$type, this.b7));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "c0", {
        get: function () {
            return this.cy;
        },
        set: function (a) {
            var b = this.cy;
            this.cy = a;
            if (b != this.cy) {
                this.bd("ComboItemsSource", b, this.cy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "c4", {
        get: function () {
            return this.c2;
        },
        set: function (a) {
            var b = this.c2;
            this.c2 = a;
            if (b != this.c2) {
                this.bd("ComboTextField", b, this.c2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCell.prototype, "b4", {
        get: function () {
            return this.b3;
        },
        set: function (a) {
            var b = this.b3;
            this.b3 = a;
            if (b != this.b3) {
                this.bd("ComboValueField", b, this.b3);
            }
        },
        enumerable: true,
        configurable: true
    });
    EditorCell.prototype.cw = function (a) {
        if (this.cp == null) {
            this.cp = this.w.createElement("div");
            var b = this.w.getSubRenderer(this.cp);
            this.cc = new Popup();
            this.cc.provideRenderer(b);
            this.cr = this.w.createElement("div");
            this.cr.setStyleProperty("background-color", "rgba(0,0,0,0.7)");
            this.cr.setStyleProperty("color", "#fff");
            this.cr.setStyleProperty("padding", "5px");
            this.cr.setStyleProperty("outline", "none");
            this.cr.setAttribute("tabindex", "-1");
            this.cq = this.w.createElement("div");
            this.cq.setStyleProperty("white-space", "pre");
            if (this.ce != null) {
                this.cq.setStyleProperty("font", this.ce.fontString);
            }
            this.cr.append(this.cq);
            this.cc.appendPopupContent(this.cr);
        }
        var c = null;
        switch (a) {
            case 0:
                c = this.cv();
                break;
            case 1:
                c = this.cu();
                break;
        }
        return c;
    };
    EditorCell.prototype.cv = function () {
        if (this.ct != null) {
            this.dh();
            this.dj();
            return this.ct;
        }
        this.ct = this.w.createElement("div");
        this.ct.setRawStyleProperty("display", "flex");
        this.ct.setRawStyleProperty("width", "100%");
        this.ct.setRawStyleProperty("margin-top", "-10px");
        this.ct.setRawStyleProperty("height", "38px");
        this.cl = this.w.getSubRenderer(this.ct);
        this.cb = new InputGroup();
        this.cb.provideContainer(this.cl);
        this.cb.j = 0;
        this.cb.d = this.d.getTheme();
        this.cb.h = 3;
        this.cs = this.w.createElement("div");
        this.cs.setRawStyleProperty("width", "100%");
        this.cm = this.w.getSubRenderer(this.cs);
        this.ca = new Input();
        this.ca.provideContainer(this.cm);
        this.ca.bq = "text";
        var a = this.ca;
        a.changing = delegateCombine(a.changing, runOn(this, this.dl));
        this.cb.appendContentChild(this.cs);
        this.cb.inputs.add(this.ca);
        return this.ct;
    };
    EditorCell.prototype.cu = function () {
        var _this = this;
        if (this.cn != null) {
            this.de();
            this.dh();
            this.dj();
            return this.cn;
        }
        this.cn = this.w.createElement("div");
        this.cn.setRawStyleProperty("margin-top", "-10px");
        this.cn.setRawStyleProperty("height", "38px");
        this.cn.setRawStyleProperty("width", "100%");
        this.w.getPortal(this.cn, "MultiColumnComboBox", function (a) {
            _this.b9 = a.componentRef;
            _this.b9.height = "100%";
            _this.b9.density = 3;
            _this.b9.baseTheme = _this.d.getTheme();
            _this.b9.labelVisible = false;
            _this.b9.columnHeadersVisible = false;
            _this.b9.rowSeparatorsVisible = false;
            _this.de();
            _this.dr();
            _this.dh();
            _this.dj();
            _this.cx = _this.b9.i;
            _this.cx.valueChanged = delegateCombine(_this.cx.valueChanged, runOn(_this, _this.onComboValueChanged));
            _this.cx.textChanged = delegateCombine(_this.cx.textChanged, runOn(_this, _this.onComboTextChanged));
            _this.cx.gotFocus = delegateCombine(_this.cx.gotFocus, runOn(_this, _this.onComboGotFocus));
            _this.cx.lostFocus = delegateCombine(_this.cx.lostFocus, runOn(_this, _this.onComboLostFocus));
        }, false);
        return this.cn;
    };
    EditorCell.prototype.dk = function (a, b) {
        if (b.g != b.d || b.h != b.e) {
            if (this.b9 != null) {
                this.b9.closeUp();
            }
            this.db();
        }
    };
    EditorCell.prototype.dq = function (a) {
        var _this = this;
        this.ch = false;
        this.ci = false;
        this.cg = true;
        if (!a) {
            this.ci = true;
            if (this.b8 == 0) {
                if (this.ca != null) {
                    this.ca.b8();
                    if (this.ca.bq != "date") {
                        window.setTimeout(function () { return _this.ca.cv(); }, 0);
                    }
                }
            }
            else if (this.b8 == 1) {
                if (this.b9 != null) {
                    if (this.b9.value == null && this.b9.text != "") {
                        this.b9.text = "";
                    }
                    this.b9.focus();
                    this.b9.select();
                }
            }
        }
    };
    EditorCell.prototype.dr = function () {
        if (this.b8 == 0) {
            if (this.ca != null) {
                if (this.c1 != null) {
                    if (this.b6 == 8) {
                        var a = this.c1;
                        var b = dateGetMonth(a) < 10 ? "0" + dateGetMonth(a) : dateGetMonth(a).toString();
                        var c = a.getDate() < 10 ? "0" + a.getDate() : a.getDate().toString();
                        this.ca.b4 = null;
                        this.ca.b4 = a.getFullYear() + "-" + b + "-" + c;
                    }
                    else {
                        this.ca.b4 = null;
                        this.ca.b4 = this.c1.toString();
                    }
                    this.b.updateCellEditValue(this.ca.b4);
                }
                else {
                    this.ca.b4 = null;
                }
            }
        }
        else if (this.b8 == 1) {
            if (this.b9 != null) {
                this.b9.value = this.c1;
            }
        }
    };
    EditorCell.prototype.dh = function () {
        if (this.b8 == 0) {
            switch (this.b6) {
                case 10:
                case 6:
                case 5:
                case 1:
                case 3:
                case 4:
                case 7:
                    this.ca.bq = "number";
                    break;
                case 8:
                    this.ca.bq = "date";
                    break;
                default:
                    this.ca.bq = "text";
                    break;
            }
        }
    };
    EditorCell.prototype.di = function () {
        this.cf = true;
        this.z.removeChildren();
        this.co = this.cw(this.b8);
        this.z.append(this.co);
        this.cf = false;
    };
    EditorCell.prototype.de = function () {
        if (this.b9 != null) {
            if (this.c4 != null) {
                this.b9.autoGenerateDesiredProperties = [this.c4];
            }
            else if (this.b4 != null && this.b4.length > 0) {
                this.b9.autoGenerateDesiredProperties = [this.b4[0]];
            }
            else {
                var a = typeCast(IDataSource_$type, this.c0);
                if (a != null && a.actualSchema != null) {
                    this.b9.autoGenerateDesiredProperties = [a.actualSchema.propertyNames[0]];
                }
                else {
                    var b = (Array.isArray(this.c0));
                    if (b) {
                        var c = (Object.keys(this.c0[0]));
                        if (c.length > 0) {
                            this.b9.autoGenerateDesiredProperties = [c[0]];
                        }
                    }
                }
            }
            this.b9.dataSource = this.c0;
            this.b9.textField = this.c4;
            this.b9.valueField = this.b4;
        }
    };
    EditorCell.prototype.dj = function () {
        if (this.ce != null) {
            if (this.b8 == 0) {
                if (this.ca != null) {
                    this.ca.aa = this.ce;
                }
            }
            else if (this.b8 == 1) {
                if (this.b9 != null) {
                    this.b9.textStyle = this.ce.fontString;
                }
            }
            this.cq.setStyleProperty("font", this.ce.fontString);
        }
    };
    EditorCell.prototype.ds = function (a, b, c, d, e) {
        if (!stringIsNullOrWhiteSpace(a)) {
            this.cq.setRawText(a);
            this.dt();
        }
    };
    EditorCell.prototype.dt = function () {
        var rect_ = this.z.getNativeElement().getBoundingClientRect();
        var a = new Rect(4);
        a.left = (rect_.left + window.pageXOffset);
        a.top = (rect_.top + window.pageYOffset);
        a.right = (rect_.right + window.pageXOffset);
        a.bottom = (rect_.bottom + window.pageYOffset);
        this.cc.showRelativeToExclusionRect(a, 1, 0);
    };
    EditorCell.prototype.db = function () {
        if (this.cc.o) {
            this.cc.ac();
        }
    };
    EditorCell.prototype.bc = function () {
        if (this.co == null) {
            this.di();
            this.d.setViewportChangedHandler(runOn(this, this.dk));
        }
    };
    EditorCell.prototype.bd = function (a, b, c) {
        _super.prototype.bd.call(this, a, b, c);
        switch (a) {
            case "EditorType":
                this.di();
                break;
            case "ComboItemsSource":
            case "ComboTextField":
            case "ComboValueField":
                this.de();
                break;
            case "DataType":
                this.dh();
                break;
            case "Value":
                this.dr();
                break;
            case "FontInfo":
                this.dj();
                break;
        }
    };
    EditorCell.prototype.onComboValueChanged = function (a, b) {
        this.du();
    };
    EditorCell.prototype.onComboTextChanged = function (a, b) {
        this.du();
    };
    EditorCell.prototype.du = function () {
        if (this.ci && this.b8 == 1) {
            if (this.b9.value != null) {
                this.b.updateCellEditValue(this.b9.value);
            }
            else if (this.b9.value == null && stringIsNullOrWhiteSpace(this.b9.text)) {
                this.b.updateCellEditValue(null);
            }
            else {
                this.b.updateCellEditValue(this.c1);
            }
        }
    };
    EditorCell.prototype.dl = function (a, b) {
        this.b.updateCellEditValue(b.value);
    };
    EditorCell.prototype.dp = function (a) {
        switch (BaseDOMEventProxy.cu(a)) {
            case 14:
            case 16:
            case 15:
            case 17:
                a.stopPropagation();
                break;
        }
    };
    EditorCell.prototype.ck = function (a) {
        if (a != null && this.cc != null && this.cc.o) {
            var b = this.cr.getNativeElement();
            return b.contains(a);
        }
        return false;
    };
    EditorCell.prototype.cj = function (a) {
        if (a != null) {
            var b = this.z.getNativeElement();
            return b.contains(a);
        }
        return false;
    };
    EditorCell.prototype.dn = function (a) {
        if (!this.cf) {
            var b = (a.originalEvent.relatedTarget);
            if (this.cg && !this.cj(b) && !this.ck(b)) {
                this.b.editorCellLostFocus();
                this.db();
            }
        }
    };
    EditorCell.prototype.dm = function (a) {
        if (this.ch && !this.cc.o) {
            this.dt();
        }
    };
    EditorCell.prototype.onComboLostFocus = function (a) {
        this.cg = true;
    };
    EditorCell.prototype.onComboGotFocus = function (a) {
        this.cg = false;
    };
    EditorCell.prototype.onContactStarted = function (a, b) {
        a.stopPropagation();
    };
    EditorCell.prototype.onContactMoved = function (a, b) {
        a.stopPropagation();
    };
    EditorCell.prototype.onContactCompleted = function (a, b) {
        a.stopPropagation();
    };
    EditorCell.prototype.ba = function (a, b) {
        a.stopPropagation();
    };
    EditorCell.prototype.onDoubleClick = function (a) {
        a.stopPropagation();
    };
    EditorCell.$t = markType(EditorCell, 'EditorCell', GridCellBase.$);
    return EditorCell;
}(GridCellBase));
export { EditorCell };
//# sourceMappingURL=EditorCell.js.map
